<template>
  <div class="bg-black w-full h-full">
    <slot />
  </div>
</template>
